(function () {
  const SEED_SELECTOR = 'divano-availability-badge[data-source="true"]';
  const SLIDE_SELECTOR = '.product-media-container';
  const CLONE_MARKER = 'data-divano-badge-clone';
  const BAND_PROPERTIES = {
    inlineStart: '--divano-badge-band-inline-start',
    inlineEnd: '--divano-badge-band-inline-end',
    blockStart: '--divano-badge-band-block-start',
    blockEnd: '--divano-badge-band-block-end',
  };

  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(placeBadges) : null;

  function offsetWithin(el, ancestor) {
    let x = 0;
    let y = 0;
    let node = el;
    while (node && node !== ancestor) {
      x += node.offsetLeft;
      y += node.offsetTop;
      node = node.offsetParent;
    }
    return node === ancestor ? { x, y } : null;
  }

  function axisOffset(position, freeSpace) {
    const value = parseFloat(position);
    if (Number.isFinite(value) && position.endsWith('%')) return (freeSpace * value) / 100;
    if (Number.isFinite(value) && position.endsWith('px')) return value;
    return freeSpace / 2;
  }

  function photoBands(slide) {
    const none = { left: 0, right: 0, top: 0, bottom: 0 };
    const img = slide.querySelector('.product-media__image');
    if (!img || !img.offsetWidth || !img.offsetHeight) return none;
    const origin = offsetWithin(img, slide);
    if (!origin) return none;

    const style = window.getComputedStyle(img);
    let width = img.offsetWidth;
    let height = img.offsetHeight;
    let x = 0;
    let y = 0;
    if (style.objectFit === 'contain') {
      const intrinsicWidth = img.naturalWidth || Number(img.getAttribute('width'));
      const intrinsicHeight = img.naturalHeight || Number(img.getAttribute('height'));
      if (!intrinsicWidth || !intrinsicHeight) return none;
      const scale = Math.min(width / intrinsicWidth, height / intrinsicHeight);
      const [positionX = '50%', positionY = '50%'] = style.objectPosition.split(' ');
      x = axisOffset(positionX, width - intrinsicWidth * scale);
      y = axisOffset(positionY, height - intrinsicHeight * scale);
      width = intrinsicWidth * scale;
      height = intrinsicHeight * scale;
    }

    const left = origin.x + x;
    const top = origin.y + y;
    return {
      left,
      top,
      right: slide.clientWidth - left - width,
      bottom: slide.clientHeight - top - height,
    };
  }

  function placeBadges(entries) {
    const updates = [];
    for (const { target: slide } of entries) {
      const clone = slide.querySelector(`[${CLONE_MARKER}]`);
      if (!clone) continue;
      const bands = photoBands(slide);
      const rtl = window.getComputedStyle(clone).direction === 'rtl';
      updates.push([
        clone,
        {
          inlineStart: rtl ? bands.right : bands.left,
          inlineEnd: rtl ? bands.left : bands.right,
          blockStart: bands.top,
          blockEnd: bands.bottom,
        },
      ]);
    }
    for (const [clone, bands] of updates) {
      for (const [side, property] of Object.entries(BAND_PROPERTIES)) {
        clone.style.setProperty(property, `${Math.max(0, Math.round(bands[side])) || 0}px`);
      }
    }
  }

  function gallerySlides(seed) {
    const root = seed.closest('.shopify-section') || document;
    return [...root.querySelectorAll(SLIDE_SELECTOR)].filter((slide) => !slide.closest('product-card'));
  }

  function injectAll() {
    const seed = document.querySelector(SEED_SELECTOR);
    if (!seed) return;
    const slides = gallerySlides(seed);
    const bare = slides.filter((slide) => !slide.querySelector(`[${CLONE_MARKER}]`));
    const isStatic = bare.map((slide) => window.getComputedStyle(slide).position === 'static');
    bare.forEach((slide, i) => {
      if (isStatic[i]) slide.style.position = 'relative';
      const clone = seed.cloneNode(true);
      clone.removeAttribute('data-source');
      clone.setAttribute(CLONE_MARKER, '');
      clone.style.display = '';
      slide.appendChild(clone);
    });
    if (resizeObserver) for (const slide of slides) resizeObserver.observe(slide);
  }

  function init() {
    injectAll();

    document.addEventListener('variant:update', () => {
      setTimeout(injectAll, 0);
    });

    const galleryHost = document.querySelector('media-gallery');
    if (galleryHost && 'MutationObserver' in window) {
      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (n.matches?.(SLIDE_SELECTOR) || n.querySelector?.(SLIDE_SELECTOR)) {
              injectAll();
              return;
            }
          }
        }
      });
      observer.observe(galleryHost, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
